<template>
    <van-tabs v-model="active" id="recordPage">

        <van-tab title="余额充值记录" v-if="$store.state.isHeadquarterAppid=='true'">
            <div class="recordPanel">
                <div v-if="balanceRechargeRocordList.length > 0">
                    <div v-for="item in balanceRechargeRocordList" :key="item.orderNo" class="records">
                        
                        <ul class="rechargeInfo">
                            <li>
                                <label>付款单号：</label>
                                <span>{{ item.orderNo }}</span>
                            </li>
                            <li>
                                <label>付款金额：</label>
                                <span >{{money_format(item.amount/100, 2, '.', ',')}}元</span>
                            </li>
                            
                            <li>
                                <label>赠送金额：</label>
                                <span>{{money_format(item.giftBalance/100 , 2, '.', ',') }}元</span>
                            </li>
                            <li>
                                <label>付款时间：</label>
                                <span>{{ item.createTime }}</span>
                            </li>
                        </ul>     
                    </div>
                    <div class="tips">没有更多了哦</div>
                </div>
                <div v-else class="nodata">
                    <img src="@/assets/nodata.png" alt="">
                    <span>暂无数据</span>
                </div>
            </div>
        </van-tab>





    </van-tabs>
</template>
<script>
import {wxRequest} from '@/api/user.js'
export default {
    data(){
        return {
            active: 2,
            balanceRechargeRocordList: [],
            rechargeRocordList: [],
            accountFlowList: [],
        }
    },
    methods: {
        rechargeDetail(item){
            this.$router.push({
                name: 'rechargeDetail',
                query: item
            })
        }
    },
    created(){
         var iccid= this.$route.query.iccid;
         if(iccid==null){
             return
         }
         console.log(iccid)
        var data = {
            iccid: iccid
        }
        wxRequest("order/wx/user/investOrder", data, "post").then(res => {
            if(res.data.code == 200){
                this.balanceRechargeRocordList = res.data.data;
            }
        });

       
    }
}
</script>
<style lang="less">
#recordPage{
    .recordPanel {
        min-height: 100%;
        background: #f2f2f2;
        .records {
            margin-bottom: 12px;
            background: #fff;
        }
        h4 {
            display: flex;
            justify-content: space-between;
            padding: 0 4%;
            line-height: 34px;
            .money {
                color: red;
            }
        }
        ul {
            padding: 0 4%;
            border-top: 1px solid #f0f0f0;
            border-bottom: 1px solid #f0f0f0;
            li {
                line-height: 28px;
            }
        }
        .btnOuter {
            padding: 0 4%;
            line-height: 34px;
            text-align: right;
        }
        .tips {
            color: #a0a0a0;
            text-align: center;
            line-height: 28px;
        }
        .nodata {
            height: 100%;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;  
            img {
                width: 14%;
                margin: 10px;
            }   
            span{
                margin-bottom: 10px;
            }   
        }
    }
}

</style>


